import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-lines */
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { DEFAULT_DEBOUNCE_DELAY, DEFAULT_DINAMIC_MAP_URL, DEFAULT_FETCH_COEFFICIENT, DEFAULT_YANDEX_API_VERSION, DEFAULT_ZOOM_RANGE } from '../../constants';
import { getCurrentMedia, getDataForHugeFetch, getFetchData, getLanguage, sortMedia } from '../../utils';
import { MapRouteInfo } from '../MapRouteInfo';
import { NoPanorama } from '../NoPanorama/NoPanorama';
import { RulerButton, ZoomButtons } from '../CustomControls';
import { YMap } from '../YMap';
import { MapVersionError } from './errors';
import { createStyleElement } from './helpers';
import { makeCustomStyles } from './helpers/makeCustomStyles';
import * as styles from './Map.css';
import { EMapState, EMapStatus, EPanoramaState } from './types';

/**
 * React-компонент карты,
 * который используя фасад YMap
 * реализует функционал карты
 * */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Map = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Map, _React$PureComponent);
  var _super = _createSuper(Map);
  function Map() {
    var _this$props$firstPain7, _this$props$firstPain8;
    var _this;
    _classCallCheck(this, Map);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_containerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "_geoObjects", []);
    _defineProperty(_assertThisInitialized(_this), "_map", void 0);
    _defineProperty(_assertThisInitialized(_this), "_styleElement", void 0);
    _defineProperty(_assertThisInitialized(_this), "_mapStateBeforePanorama", EMapState.DEFAULT);
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeRoute: null,
      currentMedia: null,
      isFullscreen: false,
      panorama: EPanoramaState.CLOSED,
      state: EMapState.DEFAULT,
      status: EMapStatus.LOADING
    });
    _defineProperty(_assertThisInitialized(_this), "addGeoObjects", function (geoObjects) {
      _this._map.removeBalloon();
      _this._map.addGeoObjects(geoObjects);
    });
    _defineProperty(_assertThisInitialized(_this), "removeGeoObjects", function (geoObjects) {
      var shouldRemoveBalloon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this._map.removeGeoObjects(geoObjects);
      if (shouldRemoveBalloon) {
        _this._map.removeBalloon();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "removeAllGeoObjects", function () {
      _this._map.removeAllGeoObjects();
      _this._map.removeBalloon();
    });
    _defineProperty(_assertThisInitialized(_this), "resetMapState", function () {
      var currentState = _this.state.state;
      switch (currentState) {
        case EMapState.ROUTING:
          _this._map.closeRouteControl();
          break;
        case EMapState.PANORAMA:
          _this._map.closePanorama();
          break;
        default:
          return;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "startRouting", function (from, to, filter, routingMode, viewType) {
      _this._startRouting(from, to, filter, routingMode, viewType);
    });
    _defineProperty(_assertThisInitialized(_this), "fitToViewport", function () {
      _this._map.redraw();
    });
    _defineProperty(_assertThisInitialized(_this), "getZoom", function () {
      return _this._map.getZoom();
    });
    _defineProperty(_assertThisInitialized(_this), "setCenterAndZoom", function (centerCoordinates, zoom, animationDuration) {
      var currentMedia = _this.state.currentMedia;
      _this._setCenterAndZoom(_objectSpread(_objectSpread({}, currentMedia), {}, {
        options: {
          center: centerCoordinates,
          defaultZoom: zoom,
          animationDuration: animationDuration,
          styles: currentMedia.options.styles
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "addRoute", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(routeId, from, to, routingMode) {
        var zoomMargin,
          onActiveRouteChange,
          activeRoute,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              zoomMargin = _args.length > 4 && _args[4] !== undefined ? _args[4] : [0, 0];
              onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
              _this._map.removeBalloon();
              _context.next = 5;
              return _this._map.addMultiRoute(routeId, from, to, routingMode, zoomMargin);
            case 5:
              activeRoute = _context.sent;
              _this.setState({
                activeRoute: activeRoute
              });
              if (onActiveRouteChange) {
                onActiveRouteChange(activeRoute);
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "removeRoute", function (routeId) {
      var onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
      _this._map.removeMultiRoute(routeId);
      _this.setState({
        activeRoute: null
      });
      if (onActiveRouteChange) {
        onActiveRouteChange(null);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_redraw", function () {
      setTimeout(_this._map.redraw, _this.state.currentMedia.options.animationDuration + 100);
    });
    _defineProperty(_assertThisInitialized(_this), "_setCenterAndZoom", function (currentMedia) {
      _this._map.setCenterAndZoom({
        center: [currentMedia.options.center.lng, currentMedia.options.center.lat],
        zoom: currentMedia.options.defaultZoom,
        duration: currentMedia.options.animationDuration
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getDataForYMap", function (currentMedia) {
      var _this$props$firstPain = _this.props.firstPaintOptions,
        zoomRange = _this$props$firstPain.zoomRange,
        clustersOptions = _this$props$firstPain.clusters,
        restrictMapArea = _this$props$firstPain.restrictMapArea,
        onMove = _this$props$firstPain.onMove,
        maxGeoObjectsPerLoad = _this$props$firstPain.maxGeoObjectsPerLoad,
        geoObjectsLoadDelay = _this$props$firstPain.geoObjectsLoadDelay,
        disableScrollZoom = _this$props$firstPain.disableScrollZoom,
        onPanoramaButtonClick = _this$props$firstPain.onPanoramaButtonClick;
      var _currentMedia$options = currentMedia.options,
        center = _currentMedia$options.center,
        defaultZoom = _currentMedia$options.defaultZoom;
      return {
        center: center,
        defaultZoom: defaultZoom,
        clustersOptions: clustersOptions,
        restrictMapArea: restrictMapArea,
        onMove: onMove,
        onActiveRouteChange: _this._handleActiveRouteChange,
        onRouteBuildingInit: _this._handleRouteBuildingInit,
        onRouteBuildingSuccess: _this._handleRouteBuildingSuccess,
        onRoutingEnd: _this._handleEndRouting,
        onRoutingStart: _this._handleStartRouting,
        maxGeoObjectsPerLoad: maxGeoObjectsPerLoad,
        geoObjectsLoadDelay: geoObjectsLoadDelay,
        disableScrollZoom: disableScrollZoom,
        zoomRange: zoomRange || DEFAULT_ZOOM_RANGE,
        onActionEnd: _this._handleActionEndDebounced,
        onGeoObjectClick: _this._handleGeoObjectClick,
        onPanoramaButtonClick: onPanoramaButtonClick,
        onPanoramaStateChange: _this._onPanoramaStateChange,
        onFullscreenStateChange: _this._onFullscreenStateChange,
        container: _this._containerRef,
        successCallback: _this._handleYMapLoaded,
        errorCallback: _this._handleYMapError,
        onBalloonOpen: _this._handleBalloonOpen,
        onBalloonClose: _this._handleBalloonClose
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_fetchData", function (data) {
      var hugeBbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
        geoObjectNames = _this$props.geoObjectNames,
        _this$props$firstPain2 = _this$props.firstPaintOptions,
        _this$props$firstPain3 = _this$props$firstPain2.fetch,
        fetchOptions = _this$props$firstPain3 === void 0 ? {} : _this$props$firstPain3,
        zoomRange = _this$props$firstPain2.zoomRange;
      var onGeoObjectsFetch = fetchOptions.onGeoObjectsFetch,
        hasOptimization = fetchOptions.hasOptimization,
        fetchCoefficient = fetchOptions.fetchCoefficient;
      if (!onGeoObjectsFetch) {
        return;
      }
      var currentData = getFetchData({
        data: data,
        geoObjectNames: geoObjectNames
      });

      // запрашиваем данные по объектам внутри видимого bbox
      onGeoObjectsFetch(currentData).then(function (objects) {
        // добавляем новые объекты к существующим в список
        _this._geoObjects = _this._geoObjects.concat(objects);

        // добавляем новые объекты на карту предварительно их фильтруя
        _this._map.addGeoObjects(_this._filterGeoObjects(objects));

        // Если нужна оптимизация - запрашиваем данные по еще большему bbox
        // Необходимо что бы подгрузить данные для ближайших объектам заранее,
        // т.к. их скоро может посмотреть пользователь
        if (!hugeBbox && hasOptimization) {
          _this._fetchData(getDataForHugeFetch({
            data: currentData,
            fetchCoefficient: fetchCoefficient || DEFAULT_FETCH_COEFFICIENT,
            geoObjectNames: geoObjectNames,
            minZoom: (zoomRange || DEFAULT_ZOOM_RANGE).min
          }), true);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_filterGeoObjects", function (geoObjects) {
      var newGeoObjects = [];
      var i = 0;
      var j = geoObjects.length - 1;
      while (i < j) {
        _this._checkGeoObject(geoObjects[i], newGeoObjects);
        _this._checkGeoObject(geoObjects[j], newGeoObjects);
        i++;
        j--;
      }
      if (i === j) {
        _this._checkGeoObject(geoObjects[i], newGeoObjects);
      }
      return newGeoObjects;
    });
    _defineProperty(_assertThisInitialized(_this), "_filterOldAndNewGeoObjects", function (geoObjects, prevGeoObjectNames) {
      var newGeoObjects = [];
      var oldGeoObjects = [];
      var i = 0;
      var j = geoObjects.length - 1;
      while (i < j) {
        _this._checkOldAndNewGeoObjects(geoObjects[i], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
        _this._checkOldAndNewGeoObjects(geoObjects[j], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
        i++;
        j--;
      }
      if (i === j) {
        _this._checkOldAndNewGeoObjects(geoObjects[i], prevGeoObjectNames, newGeoObjects, oldGeoObjects);
      }
      return {
        newGeoObjects: newGeoObjects,
        oldGeoObjects: oldGeoObjects
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_checkGeoObject", function (geoObject, newGeoObjects) {
      if (_this.props.geoObjectNames.includes(geoObject.name)) {
        newGeoObjects.push(geoObject);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_checkOldAndNewGeoObjects", function (geoObject, prevGeoObjectNames, newGeoObjects, oldGeoObjects) {
      if (!_this.props.geoObjectNames.includes(geoObject.name) && prevGeoObjectNames.includes(geoObject.name)) {
        oldGeoObjects.push(geoObject);
      } else if (_this.props.geoObjectNames.includes(geoObject.name) && !prevGeoObjectNames.includes(geoObject.name)) {
        newGeoObjects.push(geoObject);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleYMapLoaded", function () {
      var _this$props$firstPain4 = _this.props.firstPaintOptions,
        onMapSuccess = _this$props$firstPain4.onMapSuccess,
        controls = _this$props$firstPain4.controls,
        disableScrollZoom = _this$props$firstPain4.disableScrollZoom;
      _this._map.addGeoObjects(_this._filterGeoObjects(_this._geoObjects));
      _this._map.addControls(controls);
      _this.setState({
        status: EMapStatus.LOADED
      }, function () {
        window.addEventListener('resize', _this._handleResizeDebounced, false);
        if (onMapSuccess) {
          onMapSuccess(); // вызыв обработчика загрузки карты
        }
      }); // карта загружена

      if (disableScrollZoom) {
        _this._map.disableScrollZoom();
      }
      _this._checkYMapsVersion();
    });
    _defineProperty(_assertThisInitialized(_this), "_applyCustomStyles", function () {
      var apiVersion = _this.props.firstPaintOptions.apiVersion;
      var currentVersion = apiVersion || DEFAULT_YANDEX_API_VERSION;
      var styles = makeCustomStyles(currentVersion);
      var styleElement = createStyleElement(styles);
      document.head.appendChild(styleElement);
      _this._styleElement = styleElement;
    });
    _defineProperty(_assertThisInitialized(_this), "_checkYMapsVersion", function () {
      var apiVersion = _this.props.firstPaintOptions.apiVersion;
      var requiredVersion = apiVersion || DEFAULT_YANDEX_API_VERSION;
      var currentVersion = _this._map.getVersion();
      if (currentVersion !== requiredVersion) {
        _this._handleError(new MapVersionError('Map._checkYMapsVersion', currentVersion, requiredVersion));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleYMapError", function () {
      var onMapError = _this.props.firstPaintOptions.onMapError;
      if (onMapError) {
        onMapError(); // вызов обработчика неудачной загрузки карты с ошибками
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleGeoObjectClick", function (geoObject, balloonFetchData) {
      var _this$props$firstPain5 = _this.props.firstPaintOptions,
        _this$props$firstPain6 = _this$props$firstPain5.fetch,
        fetchOptions = _this$props$firstPain6 === void 0 ? {} : _this$props$firstPain6,
        onGeoObjectClick = _this$props$firstPain5.onGeoObjectClick;
      var onBalloonHtmlFetch = fetchOptions.onBalloonHtmlFetch,
        onCustomBalloonHtmlFetch = fetchOptions.onCustomBalloonHtmlFetch;
      if (onBalloonHtmlFetch) {
        // запрашиваем html для подсказок(Balloon)
        onBalloonHtmlFetch(geoObject, balloonFetchData).then(function (html) {
          if (html) {
            // добавляем Balloon на карту
            _this._map.addBalloon(_objectSpread(_objectSpread({}, balloonFetchData), {}, {
              html: html
            }), geoObject);
          }
        });
      }
      if (onCustomBalloonHtmlFetch) {
        var customBalloonResult = onCustomBalloonHtmlFetch(geoObject, balloonFetchData);
        customBalloonResult.html.then(function (html) {
          if (html) {
            _this._map.addBalloonWithContainer(_objectSpread(_objectSpread({}, balloonFetchData), {}, {
              html: html,
              closeSelector: customBalloonResult.closeSelector
            }), geoObject);
          }
        });
      }
      if (onGeoObjectClick) {
        onGeoObjectClick(geoObject);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleDidUpdate", function (_ref2) {
      var props = _ref2.props,
        state = _ref2.state,
        prevProps = _ref2.prevProps,
        prevState = _ref2.prevState;
      //  если изменился список объектов разрешенных к отображению
      if (props.geoObjectNames.join('') !== prevProps.geoObjectNames.join('')) {
        var _this$_filterOldAndNe = _this._filterOldAndNewGeoObjects(_this._geoObjects, prevProps.geoObjectNames),
          newGeoObjects = _this$_filterOldAndNe.newGeoObjects,
          oldGeoObjects = _this$_filterOldAndNe.oldGeoObjects;
        _this._map.removeGeoObjects(oldGeoObjects); // удаляем старые объекты, которые больше не нужно показывать
        _this._map.removeBalloon();
        _this._map.addGeoObjects(newGeoObjects); // и дорисовываем объекты новых типов
      }
      // если изменились настройки, зависящие от медиа
      if (state.currentMedia && prevState.currentMedia && JSON.stringify(state.currentMedia) !== JSON.stringify(prevState.currentMedia)) {
        _this._setCenterAndZoom(state.currentMedia); // устанавливаем центр карты и зум
        _this._redraw(); // и перерисовываем карту
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleResize", function () {
      var currentMedia = getCurrentMedia(sortMedia(_this.props.media));
      _this.setState({
        currentMedia: currentMedia
      });
      _this._setCenterAndZoom(currentMedia);
      _this._redraw();
    });
    _defineProperty(_assertThisInitialized(_this), "_handleActionEndDebounced", debounce(((_this$props$firstPain7 = _this.props.firstPaintOptions.fetch) === null || _this$props$firstPain7 === void 0 ? void 0 : _this$props$firstPain7.debounceDelay) || DEFAULT_DEBOUNCE_DELAY, _this._fetchData));
    _defineProperty(_assertThisInitialized(_this), "_handleResizeDebounced", debounce(((_this$props$firstPain8 = _this.props.firstPaintOptions.fetch) === null || _this$props$firstPain8 === void 0 ? void 0 : _this$props$firstPain8.debounceDelay) || DEFAULT_DEBOUNCE_DELAY, _this._handleResize));
    _defineProperty(_assertThisInitialized(_this), "_onPanoramaStateChange", function (panorama) {
      var _this$props$firstPain9 = _this.props.firstPaintOptions,
        onPanoramaSuccessEnter = _this$props$firstPain9.onPanoramaSuccessEnter,
        onNoPanoramaEnter = _this$props$firstPain9.onNoPanoramaEnter,
        onPanoramaExit = _this$props$firstPain9.onPanoramaExit;
      if (panorama === EPanoramaState.CLOSED) {
        _this.setState({
          state: _this._mapStateBeforePanorama,
          panorama: panorama
        });
        if (onPanoramaExit) {
          onPanoramaExit();
        }
        return;
      }
      var prevMapState = _this.state.state;
      _this._mapStateBeforePanorama = prevMapState;
      _this.setState({
        state: EMapState.PANORAMA,
        panorama: panorama
      });
      if (panorama === EPanoramaState.PANORAMA && onPanoramaSuccessEnter) {
        onPanoramaSuccessEnter();
      }
      if (panorama === EPanoramaState.NO_PANORAMA && onNoPanoramaEnter) {
        onNoPanoramaEnter();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onFullscreenStateChange", function (status) {
      var _this$props$firstPain10 = _this.props.firstPaintOptions,
        onFullscreenEnter = _this$props$firstPain10.onFullscreenEnter,
        onFullscreenExit = _this$props$firstPain10.onFullscreenExit;
      _this.setState({
        isFullscreen: status
      });
      if (status && !!onFullscreenEnter) {
        onFullscreenEnter();
      }
      if (!status && !!onFullscreenExit) {
        onFullscreenExit();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onNoPanoramaButtonClick", function () {
      _this._onPanoramaStateChange(EPanoramaState.CLOSED);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleBalloonOpen", function (object) {
      var onBalloonOpen = _this.props.firstPaintOptions.onBalloonOpen;
      if (onBalloonOpen) {
        onBalloonOpen(object);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleBalloonClose", function (object) {
      var onBalloonClose = _this.props.firstPaintOptions.onBalloonClose;
      if (onBalloonClose) {
        onBalloonClose(object);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleError", function (error) {
      var onError = _this.props.firstPaintOptions.onError;
      if (onError) {
        onError(error);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_startRouting", function (from, to, filter, routingMode, viewType) {
      _this._map.removeBalloon();
      if (filter !== undefined) {
        _this._setObjectsFilter(filter);
      }
      _this._map.openRouteControl(from, to, routingMode, viewType);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleEndRouting", function () {
      var onRoutingEnd = _this.props.firstPaintOptions.onRoutingEnd;
      _this.setState({
        activeRoute: null,
        state: EMapState.DEFAULT
      });
      _this._resetObjectsFilter();
      if (onRoutingEnd) {
        onRoutingEnd();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleStartRouting", function () {
      var onRoutingStart = _this.props.firstPaintOptions.onRoutingStart;
      _this.setState({
        state: EMapState.ROUTING
      });
      if (onRoutingStart) {
        onRoutingStart();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleActiveRouteChange", function (route) {
      var onActiveRouteChange = _this.props.firstPaintOptions.onActiveRouteChange;
      _this.setState({
        activeRoute: route
      });
      if (onActiveRouteChange) {
        onActiveRouteChange(route);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleRouteBuildingInit", function (params) {
      var onRouteBuildingInit = _this.props.firstPaintOptions.onRouteBuildingInit;
      if (onRouteBuildingInit) {
        onRouteBuildingInit(params);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleRouteBuildingSuccess", function (params) {
      var onRouteBuildingSuccess = _this.props.firstPaintOptions.onRouteBuildingSuccess;
      if (onRouteBuildingSuccess) {
        onRouteBuildingSuccess(params);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_setObjectsFilter", function (filterFunction) {
      _this._map.filterGeoObjects(filterFunction);
    });
    _defineProperty(_assertThisInitialized(_this), "_resetObjectsFilter", function () {
      _this._map.filterGeoObjects(null);
    });
    return _this;
  }
  _createClass(Map, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* istanbul ignore next */
      if (typeof window === 'undefined') {
        return;
      }
      var currentMedia = getCurrentMedia(sortMedia(this.props.media));
      var _this$props$firstPain11 = this.props.firstPaintOptions,
        apiKey = _this$props$firstPain11.apiKey,
        apiVersion = _this$props$firstPain11.apiVersion,
        language = _this$props$firstPain11.language;
      var mapUrl = DEFAULT_DINAMIC_MAP_URL.replace(':version', apiVersion || DEFAULT_YANDEX_API_VERSION);
      var apiUrl = "".concat(mapUrl, "&apikey=").concat(apiKey);

      // устанавливаем текущие настройки, зависящие от медиа
      this.setState({
        currentMedia: currentMedia
      });

      // инициализируем  яндекс карты, получаем инстанс
      this._map = new YMap(this._getDataForYMap(currentMedia));
      this._map.init("".concat(apiUrl).concat(getLanguage(apiUrl, language)));
      this._applyCustomStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResizeDebounced, false);
      this._styleElement.remove();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Перерисовываем некоторые элементы карты при получении новых props.
      // Делаем это после изменения props.
      // Изменение пропс является инициатором изменений внутри карты.
      /* istanbul ignore next */
      if (this.state.status === EMapStatus.LOADED) {
        this._handleDidUpdate({
          props: this.props,
          state: this.state,
          prevProps: prevProps,
          prevState: prevState
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$_map;
      var _this$state = this.state,
        activeRoute = _this$state.activeRoute,
        status = _this$state.status,
        panorama = _this$state.panorama,
        currentMedia = _this$state.currentMedia,
        isFullscreen = _this$state.isFullscreen;
      var _this$props$firstPain12 = this.props.firstPaintOptions,
        controls = _this$props$firstPain12.controls,
        firstPaintStyles = _this$props$firstPain12.styles,
        id = _this$props$firstPain12.id,
        displayRouteInfo = _this$props$firstPain12.displayRouteInfo,
        zoomRange = _this$props$firstPain12.zoomRange,
        ExternalMapRouteInfo = _this$props$firstPain12.mapRouteInfoComponent;

      /* istanbul ignore next */
      var externalStyles = currentMedia ? currentMedia.options.styles : firstPaintStyles;
      var isRouteInfoVisible = Boolean(displayRouteInfo && activeRoute);
      var isPanoramaClosed = panorama === EPanoramaState.CLOSED;
      var ruler = (_this$_map = this._map) === null || _this$_map === void 0 ? void 0 : _this$_map.getRuler();
      var rulerControl = controls.find(function (control) {
        return control.type === 'RulerControl';
      });
      var isRulerVisible = status === EMapStatus.LOADED && Boolean(rulerControl) && ruler && isPanoramaClosed;
      var zoomControl = controls.find(function (control) {
        return control.type === 'ZoomControl';
      });
      var isZoomControlVisible = status === EMapStatus.LOADED && Boolean(zoomControl) && isPanoramaClosed;
      return /*#__PURE__*/_jsxs("div", {
        style: externalStyles,
        className: "".concat(styles['container'], " ").concat(isFullscreen ? styles['container--fullscreen'] : ''),
        children: [/*#__PURE__*/_jsx("div", {
          style: externalStyles,
          ref: this._containerRef,
          className: status !== EMapStatus.LOADED ? styles['map-hidden'] : styles['map'],
          id: id || 'map'
        }), /*#__PURE__*/_jsx("div", {
          style: externalStyles,
          className: status !== EMapStatus.LOADING ? styles['map-hidden'] : styles['map'],
          children: /*#__PURE__*/_jsx("div", {
            className: styles['preloader']
          })
        }), panorama === EPanoramaState.NO_PANORAMA && /*#__PURE__*/_jsx(NoPanorama, {
          onClick: this._onNoPanoramaButtonClick,
          isFullscreen: isFullscreen
        }), isRouteInfoVisible && (ExternalMapRouteInfo ? /*#__PURE__*/_jsx(ExternalMapRouteInfo, {
          route: activeRoute,
          isFullscreen: isFullscreen
        }) : /*#__PURE__*/_jsx("div", {
          className: styles['route-info'],
          children: /*#__PURE__*/_jsx(MapRouteInfo, {
            route: activeRoute
          })
        })), isRulerVisible && /*#__PURE__*/_jsx("div", {
          className: isFullscreen ? styles['fullscreen-ruler'] : styles['ruler'],
          children: /*#__PURE__*/_jsx(RulerButton, {
            ruler: ruler,
            control: rulerControl
          })
        }), isZoomControlVisible && /*#__PURE__*/_jsx("div", {
          className: isFullscreen ? styles['fullscreen-zoom'] : styles['zoom'],
          children: /*#__PURE__*/_jsx(ZoomButtons, {
            map: this._map,
            zoomRange: zoomRange,
            control: zoomControl
          })
        })]
      });
    }

    // ----------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------

    /** Добавляет геообъекты на карту и события для них */
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      /* istanbul ignore next */
      if (typeof window === 'undefined') {
        return null;
      }

      // устанавливаем текущие настройки, зависящие от медиа при получении новых props
      return {
        currentMedia: getCurrentMedia(sortMedia(props.media))
      };
    }
  }]);
  return Map;
}(React.PureComponent);